import React__default from 'react';
import { FormControlStatus } from './Form.types.js';
import { StyledFormControl } from './Form.styles.js';
import { useDesignSystemThemeName } from '../utils.js';
import neutral from '../../themes/neutral/index.js';

var FormControl = function FormControl(props) {
  var className = props.className,
      htmlFor = props.htmlFor,
      style = props.style,
      children = props.children,
      label = props.label,
      status = props.status,
      helpText = props.helpText,
      dataTestId = props['data-test-id'];
  var themeName = useDesignSystemThemeName();
  return /*#__PURE__*/React__default.createElement(StyledFormControl, {
    htmlFor: htmlFor,
    className: "\n          ".concat(className || '', "\n          ").concat(themeName, "\n          label-form-element-wrapper\n          ").concat(status, "\n          ").concat(status === FormControlStatus.ERROR ? 'ant-form-item-has-error' : '', "\n          ").concat(status === FormControlStatus.WARNING ? 'ant-form-item-has-warning' : '', "\n          ant-form-item-has-feedback\n        "),
    style: style,
    "data-test-id": dataTestId
  }, label, /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: neutral.spacings.xxxSmall
    }
  }, children, /*#__PURE__*/React__default.createElement("div", {
    className: "help-text"
  }, helpText || /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "\xA0"))));
};

FormControl.defaultProps = {
  status: FormControlStatus.HIDDEN,
  'data-test-id': 'form-control'
};

export { FormControl };
//# sourceMappingURL=Form.js.map
